var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-new-d__results" }, [
    _c(
      "div",
      { staticClass: "search-results-new-d _d js-search-results" },
      [
        _vm.list.length > 0
          ? [
              _vm.getSimpleSuggesting.length
                ? _c(
                    "div",
                    { staticClass: "search-results-new-d__list" },
                    _vm._l(_vm.getSimpleSuggesting, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.link,
                          staticClass: "search-results-new-d__item"
                        },
                        [
                          !item.meta.bread_crumb
                            ? _c(
                                "a",
                                {
                                  staticClass:
                                    "search-results-new-d__link js-suggest-item",
                                  attrs: { href: item.link },
                                  on: {
                                    click: function($event) {
                                      return _vm.clickLinkHandler(item.title)
                                    }
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getSearchCaption(
                                          item.title,
                                          _vm.query
                                        )
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getCategories.length
                ? _c(
                    "div",
                    { staticClass: "search-results-new-d__categories" },
                    _vm._l(_vm.getCategories, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.link,
                          staticClass: "search-results-new-d__item"
                        },
                        [
                          item.meta.bread_crumb
                            ? _c("suggest-category-item-d", {
                                key: item.link,
                                attrs: {
                                  title: item.title,
                                  link: item.link,
                                  breadcrumbs: item.meta.bread_crumb,
                                  query: _vm.query
                                },
                                on: {
                                  clickHandler: function(e) {
                                    return _vm.clickLinkHandler(e)
                                  }
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.getProductsList.length
                ? _c(
                    "div",
                    { staticClass: "search-results-new-d__products" },
                    _vm._l(_vm.getProductsList, function(item) {
                      return _c(
                        "div",
                        {
                          key: item.meta.id,
                          staticClass: "search-results-new-d__item"
                        },
                        [
                          _c("search-product", {
                            attrs: {
                              id: item.meta.id,
                              url: item.link,
                              name: item.title,
                              "price-base": item.meta.original_price,
                              price: item.meta.price,
                              "percent-discount": item.meta.discount,
                              img: item.meta.image,
                              query: _vm.query
                            },
                            on: {
                              clickHandler: function($event) {
                                return _vm.clickLinkHandler(item.title)
                              }
                            }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e()
            ]
          : !_vm.list.length
          ? [
              _vm.history.length > 0
                ? _c("div", { staticClass: "search-results-new-d__home" }, [
                    _c("div", { staticClass: "search-results-new-d__title" }, [
                      _vm._v("\n          Вы уже искали\n          "),
                      _c(
                        "button",
                        {
                          staticClass: "search-results-new-d__clear",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.$emit("clear-history")
                            }
                          }
                        },
                        [_vm._v("\n            Очистить\n          ")]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search-results-new-d__list" },
                      _vm._l(_vm.history, function(item, key) {
                        return _c(
                          "div",
                          {
                            key: item,
                            staticClass: "search-results-new-d__item"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "search-results-new-d__link js-suggest-item",
                                attrs: {
                                  href: "/search/?q=" + item,
                                  rel: "nofollow"
                                }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item) +
                                    "\n            "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "search-results-new-d__item-clear",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.$emit("clear-history", key)
                                  }
                                }
                              },
                              [
                                _c("icon", {
                                  staticClass:
                                    "search-results-new-d__item-clear-icon",
                                  attrs: {
                                    name: "Close_24",
                                    width: "24",
                                    height: "24"
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.popular.length > 0
                ? _c("div", { staticClass: "search-results-new-d__home" }, [
                    _c("div", { staticClass: "search-results-new-d__title" }, [
                      _vm._v("\n          Популярные запросы\n        ")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "search-results-new-d__list" },
                      _vm._l(_vm.popular, function(item) {
                        return _c(
                          "div",
                          {
                            key: item.phrase,
                            staticClass: "search-results-new-d__item"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "search-results-new-d__link js-suggest-item",
                                attrs: {
                                  href: "/search/?q=" + item.phrase,
                                  rel: "nofollow"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.clickLinkHandler(item.phrase)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.phrase))]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e()
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }